import { useForm } from "@mantine/form";
import {
  Button,
  Grid,
  TextInput,
  Typography,
} from "@monolith-forensics/monolith-ui";
import ButtonMenu from "../../../../../../components/Forms/components/ButtonMenu";
import RelayAPI from "../../../../../../api/RelayAPI";

export const EditRelayUserForm: React.FC<{
  defaultFormData: any;
  width?: number;
  onSubmit?: () => void;
}> = ({ defaultFormData, width, onSubmit }) => {
  const form = useForm({
    initialValues: {
      first_name: defaultFormData.first_name,
      last_name: defaultFormData.last_name,
      org: defaultFormData.org,
      address: defaultFormData.address,
      city: defaultFormData.city,
      state: defaultFormData.state,
      zipcode: defaultFormData.zipcode,
      phone: defaultFormData.phone,
    },
    validate: (values) => {
      const errors: Partial<typeof defaultFormData> = {};

      if (!values.first_name) {
        errors.first_name = "First name is required";
      }
      if (!values.last_name) {
        errors.last_name = "Last name is required";
      }
      if (!values.org) {
        errors.org = "Organization is required";
      }

      return errors;
    },
  });

  const handleSubmit = async () => {
    const validationResult = form.validate();

    if (validationResult.hasErrors) {
      return;
    }

    const formData = form.getValues();

    await RelayAPI.updateUser({
      ...formData,
      user_id: defaultFormData.user_id,
    });

    onSubmit?.();
  };

  return (
    <div style={{ width: width || "100%" }}>
      <Typography variant="h3" style={{ marginBottom: 10 }}>
        Update User
      </Typography>
      <Grid col={2}>
        <TextInput
          label="First Name"
          required={true}
          key={form.key("first_name")}
          {...form.getInputProps("first_name")}
        />
        <TextInput
          label="Last Name"
          required={true}
          key={form.key("last_name")}
          {...form.getInputProps("last_name")}
        />
        <TextInput
          label="Organization | Company"
          required={true}
          colSpan={2}
          key={form.key("org")}
          {...form.getInputProps("org")}
        />
        <TextInput
          label="Address"
          colSpan={2}
          key={form.key("address")}
          {...form.getInputProps("address")}
        />
        <TextInput
          label="City"
          key={form.key("city")}
          {...form.getInputProps("city")}
        />
        <TextInput
          label="State | Province | Region"
          key={form.key("state")}
          {...form.getInputProps("state")}
        />
        <TextInput
          label="Postal Code"
          key={form.key("zipcode")}
          {...form.getInputProps("zipcode")}
        />
        <TextInput
          label="Phone"
          key={form.key("phone")}
          {...form.getInputProps("phone")}
        />
      </Grid>
      <ButtonMenu style={{ marginTop: 20 }}>
        <Button
          variant="contained"
          color="primary"
          size="xs"
          onClick={handleSubmit}
        >
          Update User
        </Button>
      </ButtonMenu>
    </div>
  );
};
